declare global {
  interface Window {
    _mtm?: Record<string, unknown>[];
  }
}

/**
 * Push a raw payload onto the Matomo Tag Manager dataLayer (`window._mtm`).
 * A matching trigger + tag in the MTM container turns it into a Matomo request,
 * so all tracking flows through one place (see head-scripts.twig).
 */
export const pushDataLayer = (payload: Record<string, unknown>) => {
  if (typeof window === 'undefined') return;
  window._mtm = window._mtm || [];
  window._mtm.push(payload);
};

/**
 * Helper to push a Matomo event onto the dataLayer.
 *
 * Argument order matches Matomo's own `trackEvent(category, action, name, value)`
 * — keep it that way. It was briefly swapped to `(…, value, name)` without
 * updating any call site, which silently routed every label into `event_value`
 * (numeric only, so Matomo discards it) and left `event_name` empty.
 *
 * @param category e.g. 'Accordion', 'Register'
 * @param action e.g. 'Open', 'Select Tab'
 * @param name optional label, e.g. 'My Title'
 * @param value optional numeric value
 */
export const trackEvent = (
  category: string,
  action: string,
  name?: string,
  value?: number,
) => {
  pushDataLayer({
    event: 'custom_event',
    event_category: category,
    event_action: action,
    ...(name !== undefined ? { event_name: name } : {}),
    ...(value !== undefined ? { event_value: value } : {}),
  });
};
